import React from "react";
import Default from "./Default";

const Settings = () => {
    return (
        <Default />
    )
};

export default Settings;